import React, { Component } from 'react';

export default class Table_Footer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<tr>
				{/* Total label */}
				<td className="table-body">{this.props.receiver.getString("ppd_total")}</td>

				{/* Returns the total power consumption for Power A for each zone for each tenant for weekdays */}
				{Object.keys(this.props.price_info.zone.weekday).map((zone) => {
					if (this.props.price_info.zone.weekday[zone].enable) {
						return (
							<td className="table-body" style={{ textAlign: 'right' }}>{this.props.bill_data.bill == null ? 0 : this.props.bill_data.bill[this.props.tenant_name].weekday[zone][0]}</td>
						)
					}
				})}

				{/* Returns the total power consumption for Power A for each zone for each tenant for holidays*/}
				{Object.keys(this.props.price_info.zone.holiday).map((zone) => {
					if (this.props.price_info.zone.holiday[zone].enable) {
						return (
							<td className="table-body" style={{ textAlign: 'right' }}>{this.props.bill_data.bill == null ? 0 : this.props.bill_data.bill[this.props.tenant_name].holiday[zone][0]}</td>
						)
					}
				})}

			</tr>
		)
	}
}